import { useState, useCallback } from 'react';
import { ChatAgentType } from '@constants/chat-agents';

interface UseChatAgentReturn {
  activeAgent: ChatAgentType;
  handleAgentChange: (newAgent: ChatAgentType) => void;
}

export const useChatAgent = (
  onAgentChangeCallback?: (agent: ChatAgentType) => void
): UseChatAgentReturn => {
  const [activeAgent, setActiveAgent] = useState<ChatAgentType>(ChatAgentType.AI);

  const handleAgentChange = useCallback(
    (newAgent: ChatAgentType) => {
      if (newAgent === activeAgent) {
        return;
      }

      setActiveAgent(newAgent);
      onAgentChangeCallback?.(newAgent);
    },
    [activeAgent, onAgentChangeCallback]
  );


  return {
    activeAgent,
    handleAgentChange,
  };
};

